import { createContext, useContext, useState } from "react";

const ModeContext = createContext(null);

export const ModeProvider = ({ children }) => {
  const [proMode, setProMode] = useState(false);
  return (
    <ModeContext.Provider value={{ proMode, setProMode }}>
      {children}
    </ModeContext.Provider>
  );
};

export const useMode = () => {
  const ctx = useContext(ModeContext);
  if (!ctx) throw new Error("useMode must be used within ModeProvider");
  return ctx;
};
